import { Space } from "antd";
import { PickerTimeProps } from "antd/es/time-picker";
import dayjs, { Dayjs } from "dayjs";
import * as React from "react";
import { TIME_FORMAT } from "../../lib/constants";
import { useCurrentLocale } from "../../lib/hooks/basic/locales";
import {
  AntDatePicker,
  DatePicker,
  type RangePickerFormItemProps,
} from "./DatePicker";

export interface TimePickerProps
  extends Omit<PickerTimeProps<Dayjs>, "picker" | "value"> {
  value?: string;
}

export const TimePicker = React.forwardRef<any, TimePickerProps>(
  ({ value, ...props }, ref) => {
    const { antLocale } = useCurrentLocale();

    return (
      <AntDatePicker
        format={TIME_FORMAT}
        minuteStep={15}
        locale={antLocale.DatePicker}
        use12Hours
        value={value ? dayjs(value).tz() : undefined}
        {...(props as any)}
        picker="time"
        mode={undefined}
        ref={ref}
      />
    );
  }
);

export function TimeRangePickerFormItem({
  addonBefore,
  addonAfter,
  ...props
}: {
  addonBefore?: React.ReactNode;
  addonAfter?: React.ReactNode;
} & Omit<RangePickerFormItemProps, "minuteStep">) {
  const { antLocale } = useCurrentLocale();

  return (
    <Space.Compact block style={{ minWidth: "300px" }}>
      {addonBefore && (
        <span className="ant-input-group-addon">{addonBefore}</span>
      )}

      <DatePicker.RangePickerFormItem
        picker="time"
        format={TIME_FORMAT}
        minuteStep={15}
        locale={antLocale.DatePicker}
        use12Hours
        {...props}
      />

      {addonAfter && (
        <span className="ant-input-group-addon">{addonAfter}</span>
      )}
    </Space.Compact>
  );
}
